module.exports = __webpack_public_path__ + "static/top-56419d404032b1a56e323ac50e27765b.png";